// Pure helpers for the Practice Room — no network deps, unit-testable in isolation.

// Ready takes -> ascending chart points for the Trappa Keeper trend.
export function trendData(takes) {
  return (takes || [])
    .filter((t) => t.status === 'ready' && typeof t.overall === 'number')
    .map((t) => ({ take_id: t.take_id, overall: t.overall, date: t.created_at.slice(0, 10) }))
    .sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
}
